<template>
  <v-card elevation="0">
    <v-card-title>Flux de commandes</v-card-title>
    <v-card-text>
      <template v-if="loading==false">
        <line-chart :chartdata="chartdata" :options="options" :height="200"></line-chart>
      </template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import LineChart from "@/components/dashboard/charts/Line.vue";
import { mapActions } from "vuex";
export default {
  components: { LineChart },
  data: () => ({
    data: 0,
    loading: true,
    options: {
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    },
    chartdata: {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          label: "Commandes",
          fill: false,
          borderColor: "#0a252c",
          data: [40, 20, 30, 400]
        }
      ]
    }
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.orderEvolution()
        .then(data => {
          this.chartdata.labels = data.data.labels;
          this.chartdata.datasets[0].data = data.data.datas;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ...mapActions("statistique", ["orderEvolution"])
  }
};
</script>

<style>
</style>